<template>
    <b-form class="geocoder" @submit.prevent="getGeocode">
        <b-form-group class="mb-0" label="Address or Location" label-for="address" label-sr-only>
            <b-input-group>
                <b-input-group-text slot="prepend">
                    <i class="fa fa-lg fa-map-marker-alt text-info"></i>
                </b-input-group-text>
                <b-form-input
                        ref="geocodeinput"
                        v-debounce:400ms="getGeocode"
                        autocomplete="off"
                        id="address" size="lg" v-model="locationQuery"
                        @blur.native="closeUp"
                        required placeholder="Address or Location" />
                <b-button size="lg" slot="append" type="submit" variant="primary">
                    <i class="fa fa-search"></i>
                    <span class="sr-only">Look Up</span>
                </b-button>
                <select
                        ref="geocodeselect"
                        v-model="selectedAddress"
                        v-show="showselect" id="geocodeselect"  size="10" class="suggestion-list">
                  <option
                          @click="goToSelectedAddress(suggestion.match)"
                          v-for="(suggestion, index) in matches"
                          :value="suggestion.match">
                    {{ suggestion.match.place_name }}
                  </option>
                </select>
            </b-input-group>
        </b-form-group>
    </b-form>
</template>

<script>
    import axios from 'axios';
    import swal from 'sweetalert';

    export default {

        data() {
            return {
                selectedAddress:null,
                showselect:false,
                matches:[],
                locationQuery:"",
                address: "",
                lat: 0,
                lon: 0,
            }
        },

        props: {
            accessToken: null,
        },
        methods: {
            getGeocode() {

                let self = this;

                if(self.selectedAddress!=null)
                {
                    self.goToSelectedAddress(self.selectedAddress);
                    return;
                }

                let add = self.locationQuery;
                if(add=='')
                {
                    return;
                }
                let t = self.accessToken ? self.accessToken : 'pk.eyJ1IjoiamFydnVzbWRvcnkiLCJhIjoiY2pzYnhpenYxMGYwYzQ0cGQxNXhxaHEyayJ9.zK6sr8dVwTn34yZSB15HVg';
                // self.query = "40 glen oaks, youngsville, nc 27596";
                let q = encodeURIComponent(add);

                axios.get("https://api.mapbox.com/geocoding/v5/mapbox.places/" + q + ".json?country=us&limit=10&access_token=" + t).then(response => {
                    console.log(response);
                    if(response.data.features.length==0)
                    {
                        swal("Ooops!","Can't find any matching address","error");
                        return;
                    }
                    let match = self.parseGeocode(response.data.features);
                    if(match.type=='none')
                    {
                        //swal("Ooops!","Can't find any matching address","error");
                        return;
                    }
                });
            },
            clearMatches() {
              let self = this;
              self.matches = [];
              self.showselect = false;
              self.selectedAddress = null;
            },
            goToSelectedAddress(match)
            {
                this.locationQuery = match.place_name;

                this.address = match.place_name;
                this.lat = match.center[0];
                this.lon = match.center[1];
                this.$emit("foundgeocode", {
                    point: match,
                    address: this.address, lat: this.lat, lon: this.lon
                });
                this.clearMatches();
            },
            parseGeocode(geolist) {
                let self = this;
                // do we have an exact address?

                let matches = [];
                geolist.forEach(function(f)
                {
                    if(f.place_type[0]=='address')
                    {
                        console.log("first address match");
                        matches.push({type:'exact', match:f});
                    }
                    if(f.place_type[0]=='street')
                    {
                        console.log("first address match");
                        matches.push({type:'street', match:f});
                    }
                    if(f.place_type[0]=='poi')
                    {
                        console.log("first address match");
                        matches.push({type:'poi', match:f});
                    }
                    if(f.place_type[0]=='place')
                    {
                        console.log("first address match");
                        matches.push({type:'exact', match:f});
                    }
                    if(f.place_type[0]=='neighborhood')
                    {
                        console.log("first address match");
                        matches.push({type:'exact', match:f});
                    }

                });
                console.log("match");
                console.log(matches);
                self.matches = matches;
                self.showselect = matches;
                /*
                setTimeout(function() {
                    // $("#geocodeselect option:first-child").attr("selected", true);
                    //$("#geocodeselect").focus();
                },150);
                */
                return matches[0] ? matches[0] : {type:'none', match:{}};
            },
            //if we are not focused and the main input is not focused, close up
            closeUp: function() {
                var self = this;
                this.debounceBlur(function(){
                    self.showselect = false;
                });
            },
            debounceBlur: function (fn, wait = 300) {
              let timeout = null
              const timer = wait

              const debounced = (...args) => {
                const later = () => {
                  timeout = null

                  fn(...args)
                }

                clearTimeout(timeout)
                timeout = setTimeout(later, timer)

                if (!timeout) {
                  fn(...args)
                }
              }

              debounced.cancel = () => {
                clearTimeout(timeout)
                timeout = null
              }

              return debounced
            },
        }
    };
</script>

<style lang="scss">

    #geocodeselect {
        z-index:9999;
        position: absolute;
        top: 2.5em;
        left: 1.5em;
        width: 90%;
        font-size: 1.3em;
    }

    .geocoder {
        border-radius: .25rem;
        box-shadow: 0 .125rem .25rem rgba(black, .2);
        pointer-events: all;

        .input-group-prepend {
            margin: 0;
        }

        .input-group-text {
            background-color: white;
            border: 0;
            margin-right: 0;
            padding-right: 0;
        }

        input {
            border: 0;
        }
    }
</style>
